import closeIcon from "../../assets/close-icon.png";
import { useLanguage, getSenderManagementTranslation } from '../../hooks/useLanguage';

export const DeleteSender = ({closeDeleteModal,  isLoading, senderToDelete, confirmDelete }) => {
    const [isSpanish] = useLanguage();
    return (<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-999">
        <div className="bg-white p-8 rounded shadow-lg max-w-md">
            <div className='flex justify-between items-center mb-4'>
                <h2 className='text-2xl font-bold '>{getSenderManagementTranslation('confirmDeletion', isSpanish)}</h2>
                <img className='h-6 w-6 cursor-pointer' src={closeIcon} onClick={closeDeleteModal} alt="Close" />
            </div>
            <p className="mb-8">
                {getSenderManagementTranslation('areYouSureDelete', isSpanish)} "{senderToDelete.nombre}"? {getSenderManagementTranslation('thisActionCannotBeUndone', isSpanish)}
            </p>
            <div className='flex space-x-2'>
                <button
                    onClick={confirmDelete}
                    className='bg-red-600 text-white rounded-full py-2 px-5 text-sm'
                    disabled={isLoading}
                >
                    {isLoading ? getSenderManagementTranslation('deleting', isSpanish) : getSenderManagementTranslation('deleteSender', isSpanish)}
                </button>
                <button
                    onClick={closeDeleteModal}
                    className='py-2 px-2 text-sm'
                    disabled={isLoading}
                >
                    {getSenderManagementTranslation('cancel', isSpanish)}
                </button>
            </div>
        </div>
    </div>
    )
}